import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FormlyModule } from "@ngx-formly/core";
import { MaterialModule } from "../../../core/shared/material.module";
import { DynamicFormComponent } from "../../common/dynamic-form/dynamic-form.component";
import { LoadingComponent } from "../../common/loading/loading.component";

@Component({
  selector: "app-generic-form-modal",
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    FormlyBootstrapModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormComponent,
    LoadingComponent,
    MaterialModule,
  ],
  templateUrl: "./generic-form-modal.component.html",
  styleUrl: "./generic-form-modal.component.scss",
})
export class GenericFormModalComponent {
  @Input()
  configs: any = {};

  @Input()
  fields: any = [];

  activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});

  noItemFoundMessage = "No item found";
  isActive: boolean = false;

  @ViewChild(DynamicFormComponent) dynamicFormComponent!: DynamicFormComponent;

  @Output() fieldChanged = new EventEmitter<{
    field: string;
    value: any;
    modal: any;
  }>();

  constructor() {}

  onModelChange(params: { field: any; value: string }) {
    this.fieldChanged.emit({ ...params, modal: this.dynamicForm?.value });
  }

  submit() {
    this.activeModal.close(this.dynamicForm.value);
  }
}
